import { useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FLAGS, CURRENCY_NAMES } from "../data";

export default function DarkCalcDropdown({ currencies, selected, onSelect, triggerRef }) {
  // Start off-screen. useLayoutEffect fires synchronously before the browser paints,
  // so the correct position is batched into the same frame — user never sees -9999.
  const [pos, setPos] = useState({ top: -9999, right: 0 });

  useLayoutEffect(() => {
    if (!triggerRef?.current) return;
    const r = triggerRef.current.getBoundingClientRect();
    setPos({ top: r.bottom + 6, right: window.innerWidth - r.right });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Intentionally NO motion.div, NO transform, NO will-change, NO opacity animation.
  // Framer Motion GPU compositing on the card wrappers can override z-index on mobile
  // Safari when the portaled element itself is also in a compositing layer.
  // A plain div with no promoted layer forces correct CSS z-index ordering.
  return createPortal(
    <div
      data-mm-dropdown
      style={{
        position: "fixed",
        top: pos.top,
        right: pos.right,
        zIndex: 99999,
        minWidth: "172px",
        borderRadius: "12px",
        overflow: "hidden",
        padding: "4px 0",
        background: "#0C1526",
        border: "1px solid rgba(255,255,255,0.10)",
        boxShadow: "0 4px 6px rgba(0,0,0,0.3), 0 16px 40px rgba(0,0,0,0.5)",
        animation: "mmDropIn 0.12s ease both",
      }}
    >
      {currencies.map((c) => (
        <button
          key={c}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={() => onSelect(c)}
          style={{
            width: "100%", display: "flex", alignItems: "center", gap: "10px",
            padding: "10px 16px", fontSize: "12px", fontWeight: 600, cursor: "pointer",
            background: c === selected ? "rgba(16,185,129,0.12)" : "transparent",
            color:      c === selected ? "#10B981"               : "rgba(255,255,255,0.65)",
            border: "none", textAlign: "left",
          }}
          onMouseEnter={(e) => { if (c !== selected) e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
          onMouseLeave={(e) => { if (c !== selected) e.currentTarget.style.background = "transparent"; }}
        >
          <span style={{ fontSize: "15px" }}>{FLAGS[c]}</span>
          <span>{c}</span>
          <span style={{ marginLeft: "auto", fontSize: "10px", color: "rgba(255,255,255,0.24)" }}>
            {CURRENCY_NAMES[c]}
          </span>
        </button>
      ))}
    </div>,
    document.body,
  );
}
